<template>
  <div class="date-group">
    <DatePicker
      v-model="value.startDate"
      v-bind:value.sync="value.startDate"
      v-bind:pickerOptions="startPickerOptions"
      v-bind:showWeekly="showWeekly"
      v-bind:placeholder="placeholder"
      v-bind:width="width"
      v-bind:editable="editable"
      v-bind:type="type"
      v-bind:stepByWeekly="stepByWeekly"
    />
    <span>~</span>
    <DatePicker
      v-model="value.endDate"
      v-bind:value.sync="value.endDate"
      v-bind:pickerOptions="endPickerOptions"
      v-bind:showWeekly="showWeekly"
      v-bind:placeholder="placeholder"
      v-bind:width="width"
      v-bind:editable="editable"
      v-bind:type="type"
      v-bind:stepByWeekly="stepByWeekly"
      v-bind:format="format"
    />
  </div>
</template>
<script>
import DatePicker from "@/components/common/CommDatePicker";

export default {
  name: "DatePickerGroup",
  components: { DatePicker },
  props: {
    value: {
      type: Object,
      require: true,
      validator: value => {
        if(!value.hasOwnProperty("startDate" || !value.hasOwnProperty("endDate"))) {
          console.warn("v-model should be an object, and {startDate | endDate} is mandatory field.");
          return false;
        }
        return true;
      }
    },
    startPickerOptions: {
      type: Object,
      default: () => {},
    },
    endPickerOptions: {
      type: Object,
      default: () => {},
    },
    showWeekly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default() { this.$locale("calendar.inputPlaceholder"); },
    },
    width: {
      type: String,
      default: "auto",
    },
    editable: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "date",
    },
    stepByWeekly: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
    },
    isForAuto: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    "value.startDate"(newVal) {
      // this.value.endDate = newVal;
      // if (!this.isForAuto) {
      //   this.value.endDate = newVal;
      // } else if (newVal >= this.value.endDate) {
      //   this.value.endDate = this.$moment(newVal).add(1, 'day').valueOf();
      // }
      if (!this.isForAuto) {
        if (newVal > this.value.endDate) {
          this.value.endDate = newVal;
        }
      } else if (newVal >= this.value.endDate) {
        this.value.endDate = this.$moment(newVal).add(1, 'day').valueOf();
      }
      
    },
    "value.endDate"(newVal) {
      // this.value.startDate = newVal;
      // if (!this.isForAuto) {
      //   this.value.startDate = newVal;
      // } else if (newVal <= this.value.startDate) {
      //   this.value.startDate = this.$moment(newVal).subtract(1, 'day').valueOf();
      // }
      if (!this.isForAuto) {
        if (newVal < this.value.startDate) {
          this.value.startDate = newVal;
        }
      } else if (newVal <= this.value.startDate) {
        this.value.startDate = this.$moment(newVal).subtract(1, 'day').valueOf();
      }
    }
  }
};
</script>
<style lang="less" scoped>
  .date-group {
    display: inline-block;
    span{
      margin: 0 10px;
    }
  }
</style>